import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spore-test"
export default class extends Controller {
  connect() {
  }
}
